import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { Navbar } from "@/components/Navbar"
import { Hero } from "@/components/Hero"
import { About } from "@/components/About"
import { Services } from "@/components/Services"
import { Process } from "@/components/Process"
import { AdditionalServices } from "@/components/AdditionalServices"
import { WhyChooseUs } from "@/components/WhyChooseUs"
import { Gallery } from "@/components/Gallery"
import { Contact } from "@/components/Contact"
import { Footer } from "@/components/Footer"

export function App() {
  const location = useLocation()

  useEffect(() => {
    const section = location.pathname.replace("/", "")
    if (section) {
      const el = document.getElementById(section)
      if (el) {
        el.scrollIntoView({ behavior: "smooth" })
      }
    }
  }, [location.pathname])

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.1 },
    )

    document.querySelectorAll(".reveal").forEach((el) => {
      observer.observe(el)
    })

    return () => observer.disconnect()
  }, [])

  return (
    <div className="min-h-screen bg-white text-navy">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Process />
      <AdditionalServices />
      <WhyChooseUs />
      <Gallery />
      <Contact />
      <Footer />
    </div>
  )
}

export default App
